import { useCallback } from "react";
import { api } from "../lib/api";
import { DEMO_MODE } from "../lib/config";

export interface AuditPayload {
  action: "view" | "copy" | "reveal" | "submit_outcome" | "lock" | "unlock";
  patientId?: string;
  sessionId?: string;
  field?: string;
  meta?: Record<string, unknown>;
}

export function useAuditLog() {
  return useCallback(async (payload: AuditPayload) => {
    if (DEMO_MODE) {
      // demo mode — skip server call but still log to console for visibility
      // eslint-disable-next-line no-console
      console.info("[audit]", payload);
      return;
    }
    try {
      await api.post("/audit/events", payload);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("[audit] failed to write event", err);
      // In prod the server enforces audit-write-or-fail, so this catch is a safety net.
    }
  }, []);
}
